<template>
  <row :class="verticalAlignmentClass" :type="rowType">
    <template v-for="(element, index) in elements">
      <slot
        name="element"
        v-if="element"
        :element="element"
        :gridIndex="index"
        :classes="classes(index)"
      ></slot>
      <slot
        name="empty"
        v-else
        :gridIndex="index"
        :classes="classes(index)"
      ></slot>
      <div v-if="isRowEnd(index)" class="clearfix"></div>
    </template>
  </row>
</template>

<script lang="ts">
  import Vue from "vue";
  import {Hash} from "../../interfaces/hashInterfaces";
  import { VerticalAlignment } from '../../enums/verticalAlignment'
  import GridDefinition from '../../definitions/gridDefinition'

  export default Vue.extend({
    props: {
      elements: {
        type: Array as () => any[],
        required: true
      },
      layout: {
        type: Array as () => number[],
        default: () => {
          return [1]
        }
      },
      maxColumns: {
        type: Number,
        default: 12,
      },
      verticalAlignment: {
        type: Number as () => VerticalAlignment,
        default: () => VerticalAlignment.Bottom,
      },
      rowType: {
        type: String as () => 'custom' | 'bootstrap',
        default: 'custom',
      },
    },
    computed: {
      layoutTotal(): number {
        return this.layout.reduce((total, x) => {
          return total + x
        }, 0)
      },
      layoutSpots(): number {
        return this.layout.length;
      },
      verticalAlignmentClass(): string {
        return GridDefinition.getVerticalAlignmentClass(this.verticalAlignment)
      },
    },
    methods: {
      layoutWeight(index: number): number {
        const layoutIndex = index % this.layoutSpots
        return this.layout[layoutIndex] / this.layoutTotal
      },
      column(index: number): number {
        return Math.round(this.layoutWeight(index) * this.maxColumns)
      },
      classes(index: number): Hash<boolean> {
        return {
          [`col-md-${this.column(index)}`]: true,
        }
      },
      isRowEnd(index: number): boolean {
        return index % this.layoutSpots === this.layoutSpots - 1
      },
    },
  });
</script>